import Dexie from 'dexie';
import { clearPersistedOfflineFlag } from './featureFlag';

const offlineDb = new Dexie('PrismEHROffline');

offlineDb.version(1).stores({
  appointments: 'id, provider_id, patient_id, appointment_date, status, [provider_id+appointment_date]',
  patients: 'id, organization_id',
  cases: 'id, patient_id, status, [patient_id+status]',
  plansOfCare: 'id, case_id, patient_id, status, [case_id+status]',
  clinicalNotes: 'id, patient_id, case_id, encounter_id, note_type, signed, [patient_id+signed], [case_id+signed+note_type]',
  encounters: 'id, patient_id, provider_id, case_id, appointment_id, status',
  formResponses: 'id, patient_id',
  formReports: 'id, patient_id',
  templates: 'id, organization_id',
  organizationUsers: 'id, organization_id',
  appointmentTypes: 'id, organization_id',
  billingRules: 'id, organization_id',
  syncQueue: '++localId, operationType, entityType, entityId, tempId, status, priority, createdAt, [status+priority]',
  idMappings: 'tempId, serverId',
  cacheMeta: 'key',
  prefetchState: 'providerId',
});

offlineDb.version(2).stores({
  clinicalNotes: 'id, patient_id, case_id, encounter_id, note_type, signed',
  interventionCatalog: 'id, organization_id, is_active',
});

// v3 — offline mode v2: calendar feed cache (six-key /calendar-appointments
// shape), offline session snapshot for cold boot, flow sheet entries,
// invoice echoes, publicRequest cache, and richer appointment/syncQueue
// indexes. Booleans are not indexable in IndexedDB — is_active/signed/
// standalone remain JS-side filters.
offlineDb.version(3).stores({
  appointments: 'id, provider_id, patient_id, appointment_date, status, location_id, case_id, updated_at, [provider_id+appointment_date], [location_id+appointment_date]',
  calendarPatients: 'id, last_name, birthday',
  calendarCases: 'id, referring_provider_id',
  referringProviders: 'id',
  calendarUsers: 'id',
  organizations: 'id',
  locations: 'id, organization_id',
  publicCache: 'key',
  invoices: 'id, patient_id, appointment_id',
  flowSheetEntries: 'id, clinical_note_id, patient_id, case_id, encounter_id, flow_item_id, exercise_id, data_type, entry_source, recorded_at, [clinical_note_id+flow_item_id], [case_id+flow_item_id]',
  flowSheetCatalog: 'id, organization_id, category',
  offlineSession: 'key',
  syncQueue: '++localId, operationType, entityType, entityId, tempId, status, priority, createdAt, dependsOn, idempotencyKey, [status+priority]',
});

export async function clearAllData() {
  const tables = offlineDb.tables;
  await Promise.all(tables.map(table => table.clear()));
  // The persisted flag and lock marker live in localStorage (they must be
  // readable synchronously before Dexie opens) but share the cache's
  // lifetime: one purge wipes everything.
  clearPersistedOfflineFlag();
  try {
    localStorage.removeItem('prism_offline_locked');
  } catch {
    // ignore
  }
}

export default offlineDb;
